import { createContext } from "react";
import type { Job } from "./types/job";

export interface HostBridge {
  onJobApproved: (job: Job) => void;
  onAddToScene: (p: {
    jobId: string;
    videoUrl: string;
    hasVideo: boolean;
    navId?: string | null;
    // Lets the host route job types that are not a plain "add this video"
    // (talking-avatar replaces the narration and inserts the video muted).
    jobType?: string;
    result?: any;
  }) => void;
  /**
   * Raw `session_job_completed` payload, forwarded before the tray merges it.
   *
   * For job types whose result lands on a box that ALREADY exists, approval is
   * a pointless click — the author is not choosing between candidates, they are
   * waiting for a slot to fill in. `avatar-animate` is the first such type: the
   * AvatarPlayer box is on the canvas from generation, and the finished clip
   * just replaces its still. Optional, so hosts that only care about approval
   * stay unchanged.
   */
  onJobCompleted?: (completion: any) => void;
}
export const HostBridgeContext = createContext<HostBridge>({
  onJobApproved: () => {},
  onAddToScene: () => {},
});
